import { MinzeElement } from "minze";

export interface TjSeparatorIcon {}

export class TjSeparatorIcon extends MinzeElement {
  html = () => `
    <svg width="680" height="2" viewBox="0 0 680 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="1" y1="1" x2="679" y2="1" stroke="#20403E" stroke-width="2" stroke-linecap="round" stroke-dasharray="8 8"/>
    </svg>
  `;

  css = () => `
    
  `;
}
